import { TermViewer } from '@/components/organisms/TermViewer';
import { SEOHead } from '@/components/atoms/SEOHead';

/**
 * 개인정보처리방침 — sisegonggan.terms 테이블의 type='privacy' 최신 활성 버전.
 * 어드민 → 약관 관리에서 등록/수정.
 */
export function PrivacyPage() {
  return (
    <>
      <SEOHead
        title="개인정보처리방침"
        description="시세공간 개인정보처리방침 안내"
        canonical="/privacy"
      />
      <TermViewer type="privacy" fallbackTitle="개인정보처리방침" />
    </>
  );
}
